// Master Apps · Botão de download de documento — aparece ao lado de toda seta
// de navegação de documentação, SÓ para admin e SÓ quando a fonte tem download
// direto (github.com / *.sharepoint.com). O arquivo desce pelo servidor com as
// credenciais dele; ver lib/document-download.ts e a rota /api/documents.
import { useState } from 'react';
import { toast } from 'sonner';
import { IconDownload } from '@/components/icons';
import { docDownloadSource, downloadDocument } from '@/lib/document-download';
import { makePalette } from '@/lib/theme';

export function DocDownloadButton({
  applicationId,
  field,
  url,
  dark,
  accent,
  size = 26,
}: Readonly<{
  applicationId: string;
  /** Campo da API (requirements/docsTechnical/docsBusiness/docsApi/repo). */
  field: string;
  url: string | null | undefined;
  dark: boolean;
  accent: string;
  /** Lado do quadrado clicável. */
  size?: number;
}>) {
  const p = makePalette(dark);
  const [busy, setBusy] = useState(false);
  const source = docDownloadSource(url);
  if (!source) return null;

  const label = `Baixar documento (${source === 'github' ? 'GitHub' : 'SharePoint'}, via servidor)`;
  return (
    <button
      type="button"
      title={label}
      aria-label={label}
      disabled={busy}
      onClick={(e: React.MouseEvent) => {
        // O botão convive dentro/ao lado de âncoras que abrem o link: o clique
        // de baixar não pode navegar.
        e.preventDefault();
        e.stopPropagation();
        if (busy) return;
        setBusy(true);
        downloadDocument(applicationId, field)
          .catch((err: unknown) => {
            toast.error(err instanceof Error ? err.message : 'Falha ao baixar o documento');
          })
          .finally(() => setBusy(false));
      }}
      style={{
        width: size,
        height: size,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        borderRadius: 6,
        border: `1px solid ${p.border}`,
        background: p.surface2,
        color: busy ? p.placeholder : p.muted,
        cursor: busy ? 'progress' : 'pointer',
        transition: 'color 80ms, border-color 80ms',
      }}
      onMouseEnter={(e: React.MouseEvent<HTMLButtonElement>) => {
        if (busy) return;
        e.currentTarget.style.color = accent;
        e.currentTarget.style.borderColor = `${accent}66`;
      }}
      onMouseLeave={(e: React.MouseEvent<HTMLButtonElement>) => {
        e.currentTarget.style.color = busy ? p.placeholder : p.muted;
        e.currentTarget.style.borderColor = p.border;
      }}
    >
      <IconDownload size={Math.round(size * 0.5)} />
    </button>
  );
}
